function ewSetPersonalizationLoading(sectionId, isLoading, text = 'Personalisierung wird vorbereitet...') {
  const openButton = document.getElementById(`ew-open-personalization-${sectionId}`);
  const applyButton = document.getElementById(`ew-apply-personalization-${sectionId}`);
  const statusEl = document.getElementById(`ew-personalization-status-${sectionId}`);

  if (isLoading && statusEl) {
    statusEl.style.display = 'none';
    statusEl.textContent = '';
  }

  if (openButton) {
    if (!openButton.dataset.defaultText) {
      openButton.dataset.defaultText = openButton.textContent.trim();
    }
    openButton.disabled = isLoading;
    openButton.textContent = isLoading ? text : openButton.dataset.defaultText;
  }

  if (applyButton) {
    const productForm = document.querySelector('main-product-form form[action*="/cart/add"]');
    const isEditMode = !!productForm?.getAttribute('data-ew-edit-line-item-key');
    const defaultText = isEditMode
      ? 'Änderungen im Warenkorb speichern'
      : 'Personalisierung übernehmen';

    applyButton.dataset.defaultText = defaultText;
    applyButton.disabled = isLoading;
    applyButton.textContent = isLoading ? text : defaultText;
  }

  // Add-to-Cart-Button während des Ladens sperren
  const productForm = ewGetProductForm();
  if (productForm) {
    if (isLoading) {
      productForm.dataset.ewLockedByLoading = 'true';
      ewSetAddToCartLocked(productForm, true, true);
    } else {
      productForm.dataset.ewLockedByLoading = 'false';
      const isDirty = productForm.dataset.ewPersonalizationDirty === 'true';
      if (!isDirty || ewIsPersonalizationFinalized(productForm)) {
        ewSetAddToCartLocked(productForm, false);
      }
    }
  }
}

function ewRefreshPersonalizationApplyButton() {
  const productForm = document.querySelector('main-product-form form[action*="/cart/add"]');
  const applyButton = document.querySelector('[id^="ew-apply-personalization-"]');
  if (!applyButton) return;

  const isEditMode = !!productForm?.getAttribute('data-ew-edit-line-item-key');
  const nextText = isEditMode
    ? 'Änderungen im Warenkorb speichern'
    : 'Personalisierung übernehmen';

  applyButton.dataset.defaultText = nextText;
  applyButton.textContent = nextText;
  applyButton.disabled = false;
}

function ewGetPersonalizationButtonLabel(openButton) {
  let label = openButton.querySelector('.ew-personalization-btn__label');

  if (!label) {
    const currentText = openButton.textContent.trim();

    openButton.textContent = '';

    label = document.createElement('span');
    label.className = 'ew-personalization-btn__label';
    label.textContent = currentText;

    openButton.appendChild(label);
  }

  return label;
}

function ewSetPersonalizationButtonText(openButton, text, animate = true) {
  const label = ewGetPersonalizationButtonLabel(openButton);

  if (!animate) {
    label.textContent = text;
    return;
  }

  label.classList.add('is-changing');

  window.setTimeout(() => {
    label.textContent = text;

    requestAnimationFrame(() => {
      label.classList.remove('is-changing');
    });
  }, 180);
}

function ewShowPersonalizationSavedState(sectionId) {
  const openButton = document.getElementById(`ew-open-personalization-${sectionId}`);
  if (!openButton) return;

  const finalText = 'Personalisierung bearbeiten';

  openButton.dataset.defaultText = finalText;
  openButton.disabled = false;
  openButton.classList.add('is-saved');

  ewSetPersonalizationButtonText(openButton, '✓ Gespeichert', true);

  window.clearTimeout(openButton.ewSavedTimeout);

  openButton.ewSavedTimeout = window.setTimeout(() => {
    openButton.classList.remove('is-saved');
    ewSetPersonalizationButtonText(openButton, finalText, true);
  }, 3200);
}

window.ewSetPersonalizationLoading = ewSetPersonalizationLoading;
window.ewRefreshPersonalizationApplyButton = ewRefreshPersonalizationApplyButton;

function ewFindPropertyInput(productForm, propertyName) {
  return Array.from(productForm.querySelectorAll('[name^="properties["]')).find((input) => {
    return input.name === `properties[${propertyName}]`;
  });
}

function ewEnsurePropertyInput(productForm, propertyName) {
  let input = ewFindPropertyInput(productForm, propertyName);

  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[${propertyName}]`;
    productForm.appendChild(input);
  }

  return input;
}

function ewGetProductForm() {
  return document.querySelector('main-product-form form[action*="/cart/add"]');
}

function ewGetAddToCartButton(productForm) {
  if (!productForm) return null;

  return (
    productForm.querySelector('button[type="submit"][name="add"]') ||
    productForm.querySelector('button[type="submit"]') ||
    productForm.querySelector('input[type="submit"][name="add"]') ||
    productForm.querySelector('input[type="submit"]')
  );
}

function ewIsPersonalizationFinalized(productForm) {
  if (!productForm) return false;

  const designId =
    ewFindPropertyInput(productForm, '_ew_design_id')?.value ||
    productForm.querySelector('[name="properties[_ew_design_id]"]')?.value ||
    '';

  const pdfUrl =
    ewFindPropertyInput(productForm, '_pdf')?.value ||
    productForm.querySelector('[name="properties[_pdf]"]')?.value ||
    '';

  return !!designId && !!pdfUrl;
}

function ewSetAddToCartLocked(productForm, locked, showLoadingText = false) {
  const addButton = ewGetAddToCartButton(productForm);
  if (!addButton) return;

  addButton.disabled = locked;
  addButton.setAttribute('aria-disabled', locked ? 'true' : 'false');

  if (locked) {
    addButton.setAttribute('title', 'Bitte zuerst die Personalisierung übernehmen.');
    if (showLoadingText) {
      if (!addButton.dataset.ewDefaultText) {
        addButton.dataset.ewDefaultText = addButton.textContent.trim();
      }
      addButton.textContent = 'Personalisierung wird vorbereitet…';
    }
  } else {
    addButton.removeAttribute('title');
    if (addButton.dataset.ewDefaultText) {
      addButton.textContent = addButton.dataset.ewDefaultText;
      delete addButton.dataset.ewDefaultText;
    }
  }
}

function ewInstallAddToCartLock() {
  const productForm = ewGetProductForm();
  if (!productForm || productForm.dataset.ewAddToCartLockInstalled === 'true') return;

  productForm.dataset.ewAddToCartLockInstalled = 'true';
  productForm.dataset.ewPersonalizationDirty = 'false';

  function ewHasUnsavedPersonalization() {
    return productForm.dataset.ewPersonalizationDirty === 'true' &&
      !ewIsPersonalizationFinalized(productForm);
  }

  function ewMarkPersonalizationDirty() {
    productForm.dataset.ewPersonalizationDirty = 'true';
    ewSetAddToCartLocked(productForm, true);
  }

  ewSetAddToCartLocked(productForm, false);

  const personalizationCanvas = document.querySelector('[id^="ewPersonalizationCanvas-"]');

  if (personalizationCanvas) {
    personalizationCanvas.addEventListener(
      'input',
      ewMarkPersonalizationDirty,
      true
    );

    personalizationCanvas.addEventListener(
      'change',
      ewMarkPersonalizationDirty,
      true
    );

    personalizationCanvas.addEventListener(
      'click',
      function (event) {
        const changedSomething = event.target.closest(
          '#ew-add-text, label[for="ew-image-upload"], .ew-resize-handle'
        );

        if (!changedSomething) return;

        ewMarkPersonalizationDirty();
      },
      true
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      const addButton = ewGetAddToCartButton(productForm);
      const clickedAddButton = event.target.closest('button, input');

      if (!addButton || clickedAddButton !== addButton) return;

      if (productForm.getAttribute('data-ew-edit-line-item-key')) return;

      if (!ewHasUnsavedPersonalization()) {
        ewSetAddToCartLocked(productForm, false);
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      return;
    },
    true
  );

  productForm.addEventListener(
    'submit',
    function (event) {
      if (productForm.getAttribute('data-ew-edit-line-item-key')) return;

      if (!ewHasUnsavedPersonalization()) {
        ewSetAddToCartLocked(productForm, false);
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      return;
    },
    true
  );
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ewInstallAddToCartLock);
} else {
  ewInstallAddToCartLock();
}

async function ewFinalizePersonalizationDesign(productForm) {
  const designId =
    ewFindPropertyInput(productForm, '_ew_design_id')?.value ||
    productForm.querySelector('[name="properties[_ew_design_id]"]')?.value ||
    '';

  if (!designId) {
    throw new Error('Keine Design-ID für die Druckdatei gefunden.');
  }

  const printableImage =
    typeof productForm.ewGeneratePrintableImage === 'function'
      ? await productForm.ewGeneratePrintableImage()
      : '';

  const response = await fetch('/apps/everywish-personalization/personalization-design/finalize', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ designId, printableImage }),
  });

  const json = await response.json();

  if (!response.ok || !json?.success || !json?.printFileUrl) {
    throw new Error(json?.error || 'Druckdatei konnte nicht erstellt werden.');
  }

  const designConfigInput = productForm.querySelector('[name="properties[_design_config]"]');
  const previewImageInput = productForm.querySelector('[name="properties[_preview_image]"]');

  if (designConfigInput) {
    designConfigInput.value = '';
    designConfigInput.disabled = true;
  }

  if (previewImageInput) {
    previewImageInput.value = '';
    previewImageInput.disabled = true;
  }

  ewEnsurePropertyInput(productForm, 'Personalisierung').value = json.previewFileUrl || json.printFileUrl;
  ewEnsurePropertyInput(productForm, 'Zusatz: Innentext').value = 'Mit Innentext';
  ewEnsurePropertyInput(productForm, '_pdf').value = json.printFileUrl;
  ewEnsurePropertyInput(productForm, '_pplr_preview').value = 'Druckansicht';

  return json;
}

let ewApplyPersonalizationInProgress = false;

document.addEventListener('click', async function (event) {
  const applyButton = event.target.closest('[id^="ew-apply-personalization-"]');
  if (!applyButton) return;

  event.preventDefault();

  if (ewApplyPersonalizationInProgress) return;
  ewApplyPersonalizationInProgress = true;

  const idMatch = applyButton.id.match(/^ew-apply-personalization-(.+)$/);
  if (!idMatch) return;

  const sectionId = idMatch[1];
  const offcanvasEl = document.getElementById(`ewPersonalizationCanvas-${sectionId}`);
  const statusEl = document.getElementById(`ew-personalization-status-${sectionId}`);
  const openButton = document.getElementById(`ew-open-personalization-${sectionId}`);
  const productForm = document.querySelector('main-product-form form[action*="/cart/add"]');
  let showSavedFeedback = false;

  if (!productForm) {
    console.error('EW personalization: Produktformular nicht gefunden.');
    return;
  }

  const editLineItemKey = productForm.getAttribute('data-ew-edit-line-item-key') || '';

  try {
    ewSetPersonalizationLoading(
      sectionId,
      true,
      editLineItemKey ? 'Änderungen werden gespeichert...' : 'Personalisierung wird übernommen...'
    );

    const activeEditable = document.querySelector('#ew-card-editor-root .ew-editor-text-content[contenteditable="true"]:focus');
    if (activeEditable) {
      activeEditable.blur();
      await new Promise((resolve) => {
        requestAnimationFrame(() => {
          requestAnimationFrame(resolve);
        });
      });
    }

    const syncFn = productForm.ewSyncOutputs || window.ewSyncOutputs;
    if (typeof syncFn === 'function') {
      await syncFn({ generatePreview: true });
    }

    ewSetPersonalizationLoading(
      sectionId,
      true,
      editLineItemKey ? 'Änderungen werden gespeichert...' : 'Personalisierung wird übernommen...'
    );
    await ewFinalizePersonalizationDesign(productForm);
    productForm.dataset.ewPersonalizationDirty = 'false';
    ewSetAddToCartLocked(productForm, false);

    if (editLineItemKey) {
      const variantId = productForm.querySelector('[name="id"]')?.value || '';
      const editQuantity = parseInt(
        productForm.getAttribute('data-ew-edit-line-item-quantity') || '1',
        10
      );

      if (!variantId) {
        throw new Error('Keine Variant-ID gefunden.');
      }

      const propertyInputs = Array.from(
        productForm.querySelectorAll('[name^="properties["]')
      );

      const properties = {};

      propertyInputs.forEach((input) => {
        const match = input.name.match(/^properties\[(.+)\]$/);
        if (!match) return;
        properties[match[1]] = input.value || '';
      });

      delete properties._design_config;
      delete properties._preview_image;

      console.log('EW personalization properties prepared', properties);

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: editLineItemKey,
          quantity: Number.isNaN(editQuantity) ? 1 : editQuantity,
          properties
        })
      });

      if (!response.ok) {
        throw new Error('Warenkorb konnte nicht aktualisiert werden.');
      }

      const oldDesignId = productForm.getAttribute('data-ew-old-design-id') || '';
      const newDesignId = productForm.querySelector('[name="properties[_ew_design_id]"]')?.value || '';

      if (oldDesignId && oldDesignId !== newDesignId) {
        fetch('/apps/everywish-personalization/personalization-design/delete', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ designId: oldDesignId }),
        }).catch((error) => {
          console.error('EW old personalization delete failed', error);
        });
      }

      if (offcanvasEl && typeof bootstrap !== 'undefined') {
        const instance =
          bootstrap.Offcanvas.getInstance(offcanvasEl) ||
          bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl);
        instance.hide();
      }

      window.location.href = '/cart';
      return;
    }

    if (statusEl) {
      statusEl.style.display = 'none';
      statusEl.textContent = '';
    }

    showSavedFeedback = true;

    if (offcanvasEl && typeof bootstrap !== 'undefined') {
      const instance =
        bootstrap.Offcanvas.getInstance(offcanvasEl) ||
        bootstrap.Offcanvas.getOrCreateInstance(offcanvasEl);
      instance.hide();
    }
  } catch (error) {
    console.error('EW apply personalization failed', error);
    if (statusEl) {
      statusEl.style.display = 'block';
      statusEl.style.color = '#c0392b';
      statusEl.textContent = 'Fehler: Personalisierung konnte nicht übernommen werden. Bitte versuche es erneut.';
    }
    } finally {
    ewApplyPersonalizationInProgress = false;
    ewSetPersonalizationLoading(sectionId, false);
  }
});

window.addEventListener('load', async function () {
  const url = new URL(window.location.href);
  const isEditMode = url.searchParams.get('ew_edit') === '1';

  if (!isEditMode) return;

  let payload = null;

  try {
    payload = JSON.parse(sessionStorage.getItem('ew-pdp-edit-payload') || 'null');
  } catch (error) {
    console.error('EW PDP edit payload konnte nicht gelesen werden.', error);
    return;
  }

  if (!payload || !payload.lineItemKey) {
    return;
  }

  const { lineItemKey, lineItemQuantity, designConfig, oldDesignId } = payload;

  let decodedDesignConfig = designConfig || '';

  if (!decodedDesignConfig) {
    console.error('EW PDP edit mode: Keine Design-Konfiguration im Edit-Payload gefunden.');
    return;
  }

  const productForm = document.querySelector('main-product-form form[action*="/cart/add"]');
  const personalizationCanvasEl = document.querySelector('[id^="ewPersonalizationCanvas-"]');

  if (!productForm || !personalizationCanvasEl) {
    console.warn('EW PDP edit mode: Formular oder Offcanvas nicht gefunden.');
    return;
  }

  const sectionIdMatch = personalizationCanvasEl.id.match(/^ewPersonalizationCanvas-(.+)$/);
  const sectionId = sectionIdMatch ? sectionIdMatch[1] : '';

  try {
    if (window.ewSetPersonalizationLoading && sectionId) {
      window.ewSetPersonalizationLoading(
        sectionId,
        true,
        'Personalisierung wird geladen...'
      );
    }

    productForm.setAttribute('data-ew-edit-line-item-key', lineItemKey);
    productForm.setAttribute('data-ew-edit-line-item-quantity', lineItemQuantity || '1');
    productForm.setAttribute('data-ew-old-design-id', oldDesignId || '');

    if (window.ewRefreshPersonalizationApplyButton) {
      window.ewRefreshPersonalizationApplyButton();
    }

    if (typeof bootstrap !== 'undefined') {
      const personalizationCanvas =
        bootstrap.Offcanvas.getInstance(personalizationCanvasEl) ||
        bootstrap.Offcanvas.getOrCreateInstance(personalizationCanvasEl);

      await new Promise((resolve) => {
        const handleShown = () => resolve();
        personalizationCanvasEl.addEventListener('shown.bs.offcanvas', handleShown, { once: true });
        personalizationCanvas.show();
      });
    }

    await new Promise((resolve) => {
      let attempts = 0;

      function waitForEditor() {
        const editorRoot = document.querySelector('#ew-card-editor-root');

        if (
          editorRoot &&
          editorRoot.dataset.ewEditorInitialized === 'true' &&
          typeof window.ewRestoreEditorFromConfig === 'function'
        ) {
          resolve();
          return;
        }

        attempts += 1;

        if (attempts > 40) {
          resolve();
          return;
        }

        setTimeout(waitForEditor, 100);
      }

      waitForEditor();
    });

    const restored = await window.ewRestoreEditorFromConfig(decodedDesignConfig);

    if (!restored) {
      throw new Error('Personalisierung konnte nicht wiederhergestellt werden.');
    }

    sessionStorage.removeItem('ew-pdp-edit-payload');
    url.searchParams.delete('ew_edit');
    window.history.replaceState({}, '', url.toString());
  } catch (error) {
    console.error('EW PDP edit mode failed', error);
  } finally {
    if (window.ewSetPersonalizationLoading && sectionId) {
      window.ewSetPersonalizationLoading(sectionId, false);
    }
  }
});